import React from 'react';

export default function UserCommunicationEmailFooterPage() {
    return <div>UserCommunicationEmailFooterPage</div>;
}
